import { useCallback, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setSubtitlesDialogVisible } from 'store/epg/actions';
import { getSubtitlesDialogVisible } from 'store/epg/selectors';

function useAudioAndSubtitlesDialog() {
    const dispatch = useDispatch();

    const subtitlesDialogVisible = useSelector(getSubtitlesDialogVisible);

    const [subtitleButtonPosition, setSubtitleButtonPosition] = useState<
        undefined | { x: number; y: number; width: number; height: number }
    >();

    const handleSubtitlesButtonPress = useCallback(
        (buttonPosition: {
            x: number;
            y: number;
            width: number;
            height: number;
        }) => {
            setSubtitleButtonPosition(buttonPosition);
            dispatch(setSubtitlesDialogVisible(true));
        },
        [dispatch],
    );

    const handleCloseSubtitlesDialog = useCallback(() => {
        dispatch(setSubtitlesDialogVisible(false));
    }, [dispatch]);

    const handleSubtitlesModalClosed = useCallback(() => {
        setSubtitleButtonPosition(undefined);
    }, []);

    return {
        subtitlesDialogVisible,
        subtitleButtonPosition,
        onSubtitlesButtonPress: handleSubtitlesButtonPress,
        onCloseSubtitlesDialog: handleCloseSubtitlesDialog,
        onSubtitlesModalClosed: handleSubtitlesModalClosed,
    };
}

export default useAudioAndSubtitlesDialog;
